import React from "react";
import PropTypes from "prop-types";
import { constants, decodeHTMLEntities } from "@qgiv/core-js";
import ConnectedSelect from "./ConnectedSelect";
import ConnectedCheckbox from "./ConnectedCheckbox";
import ConnectedField from "./ConnectedField";

const CustomField = (props) => {
    const { name, id, type, label, description = "" } = props;
    const { FieldType } = constants.ENUMS;

    switch (type) {
        case FieldType.OLD_SHORT_TEXT:
            return (
                <ConnectedField
                    id={id}
                    name={name}
                    type="text"
                    label={label}
                    {...props}
                />
            );
        case FieldType.OLD_PARAGRAPH_TEXT:
            return (
                <ConnectedField
                    id={id}
                    name={name}
                    type="text"
                    multiline
                    label={label}
                    {...props}
                />
            );
        case FieldType.OLD_CHECKBOX:
            return (
                <ConnectedCheckbox id={id} name={name} label={label} {...props}>
                    {label}
                </ConnectedCheckbox>
            );
        case FieldType.OLD_DROPDOWN:
            return (
                <ConnectedSelect id={id} name={name} label={label} {...props}>
                    {JSON.parse(description).map((option, i) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <option key={i} value={option}>
                            {decodeHTMLEntities(option)}
                        </option>
                    ))}
                </ConnectedSelect>
            );
        default:
            return null;
    }
};

CustomField.propTypes = {
    description: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    type: PropTypes.string.isRequired,
};

export default CustomField;
